import { createContext } from 'react';

interface SubscriptionStatus {
  isActive: boolean;
  expiresAt: string | null;
  period: number;
  subscription_start_date: string | null;
}

interface User {
  name: string;
  lastName: string;
  avatar?: string;
  referralCode: string;
}

export interface UserStoreContextValue {
  user: User;
  subscriptionStatus: SubscriptionStatus;
  loading: boolean;
  error: Error | null;
  updateUser: (updates: Partial<User>) => void;
  reloadSubscription: () => Promise<void>;
  reloadUser: () => Promise<void>;
}

export const UserStoreContext = createContext<UserStoreContextValue | undefined>(undefined);

